var map = {
	"./(USDC:DAI).png": 536,
	"./(USDC:USDT).png": 537,
	"./BASE.png": 226,
	"./DAI.png": 538,
	"./LONG.png": 539,
	"./PUNK.png": 540,
	"./STECRV-1.png": 541,
	"./STECRV.png": 542,
	"./STETH.png": 543,
	"./SUSHI.png": 544,
	"./UNI.png": 545,
	"./USDC.png": 546,
	"./USDN.png": 547,
	"./USDN3CRV-1.png": 548,
	"./USDN3CRV.png": 549,
	"./USDT.png": 550,
	"./WETH.png": 551,
	"./poweredpolygon.png": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;